module.exports = __webpack_public_path__ + "9cf99d740af8a976244e82d6f714efb6.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau07.jpg
// module id = 522
// module chunks = 0